import uniqBy from 'lodash/uniqBy';
import { isUndefined, omitBy, uniq } from 'lodash';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_TRANSMISSIONS_FIELD_NAME, DESIGN_FEATURES_FIELD_NAME, TRANSMISSIONS_FIELD_NAME, variant1, variant2, variant3, variant4, } from './constants';
import { MARINE_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME } from '../../../utils/constants';
import { getComponentFromRoute } from '../../../utils/sitecorePlaceholders';
import { getExteriorColoursFromTrim, getFilteredModels, getTrimFilterValues } from '../../ModelFiltersContext/utils';
import { getGtmTagValue, gtmEvent } from '../../../utils/gtmEvents';
import getMappedFields from '../../ModelCardWithTrims/service/getMappedFields';
const modelDataComponentNames = ['MarineCategoryWithProducts', 'ModelCardWithTrims'];
export const getModelDataFromSitecoreRoute = (route, appName) => {
    const sideNavLayout = getComponentFromRoute('SideNavLayout', route);
    const components = sideNavLayout &&
        (sideNavLayout === null || sideNavLayout === void 0 ? void 0 : sideNavLayout.placeholders['side-nav-column-right'].filter((c) => modelDataComponentNames.includes(c.componentName)));
    const modelData = components
        ? components.map((c) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = getMappedFields(c === null || c === void 0 ? void 0 : c.fields, appName)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.model) === null || _d === void 0 ? void 0 : _d.fields; })
        : [];
    return modelData === null || modelData === void 0 ? void 0 : modelData.filter((d) => !!d);
};
export const getModelListFiltersFieldsDataFromSitecoreRoute = (route) => {
    var _a, _b;
    const sideNavLayout = getComponentFromRoute('SideNavLayout', route);
    const components = sideNavLayout &&
        (sideNavLayout === null || sideNavLayout === void 0 ? void 0 : sideNavLayout.placeholders['side-nav-column-left'].filter((c) => c.componentName === 'ModelListFilters'));
    return (_b = (_a = components === null || components === void 0 ? void 0 : components[0]) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : [];
};
export const getFilterableComponentsFromSitecoreRoute = (route, componentName) => {
    if (componentName !== 'FutureVehicleCard' && componentName !== 'NsxModelCard') {
        // eslint-disable-next-line no-console
        console.warn('getFilterableComponentsFromSitecoreRoute: componentName must be either "FutureVehicleCard" or "NsxModelCard"');
    }
    const sideNavLayout = getComponentFromRoute('SideNavLayout', route);
    const filterableComponents = sideNavLayout &&
        (sideNavLayout === null || sideNavLayout === void 0 ? void 0 : sideNavLayout.placeholders['side-nav-column-right'].filter((c) => c.componentName === componentName));
    return filterableComponents && filterableComponents.length > 0;
};
/**
 * @param {Object} modelData - from Sitecore route
 * @returns array of all trims, from all models and model years
 */
const getAllTrimsFromModelData = (modelData = []) => {
    const trims = [];
    modelData === null || modelData === void 0 ? void 0 : modelData.forEach((model) => {
        var _a;
        (_a = model === null || model === void 0 ? void 0 : model.modelYears) === null || _a === void 0 ? void 0 : _a.forEach((modelYear) => {
            var _a;
            (_a = modelYear === null || modelYear === void 0 ? void 0 : modelYear.trims) === null || _a === void 0 ? void 0 : _a.forEach((trim) => {
                var _a, _b;
                return trims.push({
                    ...trim,
                    modelName: (_a = model === null || model === void 0 ? void 0 : model.modelName) === null || _a === void 0 ? void 0 : _a.value,
                    modelYear: (_b = modelYear === null || modelYear === void 0 ? void 0 : modelYear.year) === null || _b === void 0 ? void 0 : _b.value,
                });
            });
        });
    });
    return trims;
};
/**
 * @param {Object} modelData - from Sitecore route
 * @param {String} modelName - Category name
 * @returns products length from all models
 */
export const isCategoryHasProducts = (modelData = [], modelName) => {
    var _a;
    const products = getAllTrimsFromModelData(modelData);
    return (_a = products === null || products === void 0 ? void 0 : products.filter(i => (i === null || i === void 0 ? void 0 : i.modelName) === modelName)) === null || _a === void 0 ? void 0 : _a.length;
};
export const getYearsFromModelData = (modelData = []) => {
    var _a;
    const years = [];
    modelData === null || modelData === void 0 ? void 0 : modelData.forEach((model) => { var _a; return (_a = model === null || model === void 0 ? void 0 : model.modelYears) === null || _a === void 0 ? void 0 : _a.map(({ year }) => years.push(year === null || year === void 0 ? void 0 : year.value)); });
    return (_a = uniq(years)) === null || _a === void 0 ? void 0 : _a.sort((a, b) => parseInt(a, 10) - parseInt(b, 10)).reverse().filter(i => i);
};
export const getModelNamesFromModelData = (modelData = []) => {
    const models = modelData === null || modelData === void 0 ? void 0 : modelData.map((model) => { var _a; return (_a = model === null || model === void 0 ? void 0 : model.modelName) === null || _a === void 0 ? void 0 : _a.value; });
    return uniq(models);
};
export const getModelNamesFromFieldsData = (fields) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const productTypes = (_f = (_e = (_d = (_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.filterType) === null || _c === void 0 ? void 0 : _c.find(type => { var _a, _b; return ((_b = (_a = type === null || type === void 0 ? void 0 : type.filterCategory) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.name) === 'productType'; })) === null || _d === void 0 ? void 0 : _d.filterCategory) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.items;
    return ((_g = productTypes === null || productTypes === void 0 ? void 0 : productTypes.map(({ filterName, name }) => ({
        modelName: name,
        displayName: filterName.value,
    }))) !== null && _g !== void 0 ? _g : []);
};
export const getGtmTagsFromModelData = (modelData = []) => {
    const gtmNames = modelData === null || modelData === void 0 ? void 0 : modelData.map((model) => { var _a; return (_a = model === null || model === void 0 ? void 0 : model.category) === null || _a === void 0 ? void 0 : _a.name; });
    return uniq(gtmNames);
};
export const getSpecialTrimNamesFromModelData = (modelData = []) => {
    const specialTrimNames = [];
    modelData === null || modelData === void 0 ? void 0 : modelData.forEach(({ modelYears }) => modelYears === null || modelYears === void 0 ? void 0 : modelYears.forEach(({ trims }) => trims === null || trims === void 0 ? void 0 : trims.forEach(({ specialVehicleType }) => {
        var _a, _b, _c;
        const name = (_c = (_b = (_a = specialVehicleType === null || specialVehicleType === void 0 ? void 0 : specialVehicleType.item) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.specialVehicleTypeName) === null || _c === void 0 ? void 0 : _c.value;
        if (name) {
            specialTrimNames.push(name);
        }
    })));
    return uniq(specialTrimNames);
};
export const getExteriorColorsFromModelData = (modelData = []) => {
    const trims = getAllTrimsFromModelData(modelData);
    const exteriorColors = [];
    trims === null || trims === void 0 ? void 0 : trims.forEach(trim => {
        const trimColors = getExteriorColoursFromTrim(trim);
        trimColors === null || trimColors === void 0 ? void 0 : trimColors.forEach(color => {
            exteriorColors === null || exteriorColors === void 0 ? void 0 : exteriorColors.push(color);
        });
    });
    return uniqBy(exteriorColors, 'detKey.value');
};
export const getTransmissionNamesFromModelData = (modelData = []) => {
    const transmissions = [];
    const trims = getAllTrimsFromModelData(modelData);
    trims === null || trims === void 0 ? void 0 : trims.forEach(trim => {
        var _a, _b;
        const trimTransmissions = (_b = (_a = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.items;
        trimTransmissions === null || trimTransmissions === void 0 ? void 0 : trimTransmissions.forEach((transmission) => {
            var _a;
            transmissions === null || transmissions === void 0 ? void 0 : transmissions.push((_a = transmission === null || transmission === void 0 ? void 0 : transmission.transmissionName) === null || _a === void 0 ? void 0 : _a.value);
        });
    });
    return uniq(transmissions);
};
export const getBodyTypesFromFilterTypes = (filterTypes) => {
    var _a, _b, _c;
    const bodyTypesFilter = filterTypes === null || filterTypes === void 0 ? void 0 : filterTypes.find((f) => { var _a, _b; return ((_b = (_a = f === null || f === void 0 ? void 0 : f.filterCategory) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.name) === 'bodyType'; });
    return (_c = (_b = (_a = bodyTypesFilter === null || bodyTypesFilter === void 0 ? void 0 : bodyTypesFilter.filterCategory) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map((i) => ({
        key: i === null || i === void 0 ? void 0 : i.name,
        value: i === null || i === void 0 ? void 0 : i.filterName.value,
    }));
};
/**
 * @param {Object} filter - filter object
 * @param {String} category - filter category
 * @param {String} item - filter item
 * @param {Object} modelData - from Sitecore route
 * @returns true if no filtered trims have the specificed item
 */
export const isFilterItemDisabled = (filter, category, item, modelData) => {
    var _a, _b;
    if (typeof window === 'undefined')
        return false;
    if ((filter === null || filter === void 0 ? void 0 : filter.onlyFutureVehicles) || (filter === null || filter === void 0 ? void 0 : filter.onlyNsx))
        return true;
    const allTrims = getAllTrimsFromModelData(modelData);
    const allTrimsWithFilterValues = allTrims === null || allTrims === void 0 ? void 0 : allTrims.map(trim => ({
        ...trim,
        filterValues: getTrimFilterValues(trim),
    }));
    const filteredTrims = getFilteredModels(allTrimsWithFilterValues, filter === null || filter === void 0 ? void 0 : filter.values);
    const trimCountForFilterItem = (_b = getFilteredModels(filteredTrims, {
        ...filter === null || filter === void 0 ? void 0 : filter.values,
        [category]: (_a = filter === null || filter === void 0 ? void 0 : filter.values[category]) === null || _a === void 0 ? void 0 : _a.concat(item),
    })) === null || _b === void 0 ? void 0 : _b.length;
    return trimCountForFilterItem === 0;
};
/**
 * Unlike other filter values (e.g. body type), exterior colours can vary
 * from one trim's transmission to another.
 * @param {Object} filter - filter object
 * @param {String} colorKey - an exterior color's unique key
 * @param {Object} modelData - from Sitecore route
 * @returns true if no transmission has the specificed color
 */
export const isExteriorColorDisabled = (filter, colorKey, modelData) => {
    var _a;
    if (typeof window === 'undefined')
        return false;
    if ((filter === null || filter === void 0 ? void 0 : filter.onlyFutureVehicles) || (filter === null || filter === void 0 ? void 0 : filter.onlyNsx))
        return true;
    const allTrims = getAllTrimsFromModelData(modelData);
    const allTrimsWithFilterValues = allTrims === null || allTrims === void 0 ? void 0 : allTrims.map(trim => ({
        ...trim,
        filterValues: getTrimFilterValues(trim),
    }));
    const filteredTrims = getFilteredModels(allTrimsWithFilterValues, filter === null || filter === void 0 ? void 0 : filter.values);
    const transmissions = [];
    filteredTrims === null || filteredTrims === void 0 ? void 0 : filteredTrims.forEach((trim) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = trim.transmissions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.forEach((transmission) => {
            var _a, _b, _c, _d, _e;
            // check all transmissions, or only the selected ones
            if (((_b = (_a = filter === null || filter === void 0 ? void 0 : filter.values) === null || _a === void 0 ? void 0 : _a.transmissionName) === null || _b === void 0 ? void 0 : _b.length) === 0 ||
                ((_d = (_c = filter === null || filter === void 0 ? void 0 : filter.values) === null || _c === void 0 ? void 0 : _c.transmissionName) === null || _d === void 0 ? void 0 : _d.includes((_e = transmission === null || transmission === void 0 ? void 0 : transmission.transmissionName) === null || _e === void 0 ? void 0 : _e.value))) {
                transmissions === null || transmissions === void 0 ? void 0 : transmissions.push(transmission);
            }
        });
    });
    const allColors = [];
    transmissions === null || transmissions === void 0 ? void 0 : transmissions.forEach((transmission) => {
        var _a, _b, _c;
        (_c = (_b = (_a = transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.forEach((color) => {
            var _a, _b, _c, _d;
            allColors === null || allColors === void 0 ? void 0 : allColors.push((_d = (_c = (_b = (_a = color === null || color === void 0 ? void 0 : color.color) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.detKey) === null || _d === void 0 ? void 0 : _d.value);
        });
    });
    const transmissionCountForColorKey = (_a = allColors === null || allColors === void 0 ? void 0 : allColors.filter(c => c === colorKey)) === null || _a === void 0 ? void 0 : _a.length;
    return transmissionCountForColorKey === 0;
};
/**
 * Pushes reset_filter gtm event
 * @param appName
 */
export const pushGtmResetFiltersEvent = (appName) => {
    const gtmPayload = {
        event: 'filter_reset',
    };
    switch (appName) {
        case MARINE_SITE_NAME:
        case PE_SITE_NAME:
        case PSP_SITE_NAME:
            gtmEvent(gtmPayload);
            break;
        default:
            break;
    }
};
export const getPECategory = (filter) => {
    if (!filter || !(filter === null || filter === void 0 ? void 0 : filter.model))
        return '';
    const productUse = (filter === null || filter === void 0 ? void 0 : filter.productUse) ? `productUse:${filter === null || filter === void 0 ? void 0 : filter.productUse}, ` : '';
    const fuelType = (filter === null || filter === void 0 ? void 0 : filter.fuelType) ? `fuelType:${filter === null || filter === void 0 ? void 0 : filter.fuelType}, ` : '';
    const startType = (filter === null || filter === void 0 ? void 0 : filter.startType) ? `startType:${filter === null || filter === void 0 ? void 0 : filter.startType}, ` : '';
    const attachment = (filter === null || filter === void 0 ? void 0 : filter.attachment) ? `attachment:${filter === null || filter === void 0 ? void 0 : filter.attachment}, ` : '';
    const peCategory = `${filter === null || filter === void 0 ? void 0 : filter.model}: ${productUse}${fuelType}${startType}${attachment}`;
    return (peCategory === null || peCategory === void 0 ? void 0 : peCategory.slice(0, -2)) || '';
};
/**
 * Pushes list of categories selected gtm event
 * @param {Object} filter - filter selected by user
 * @param {Number} trimsAvailable - how many trims are available on selected filter
 * @param {String} appName - check for app site name
 * @param maxPrice
 * @param minPrice
 * @param vehicleType
 */
export const pushGtmSelectCategoryFilterEvent = (filter, trimsAvailable, appName, maxPrice, minPrice, vehicleType) => {
    var _a;
    // switch case
    let gtmPayload;
    switch (appName) {
        case MARINE_SITE_NAME:
            gtmPayload = {
                filters: {
                    category: (filter === null || filter === void 0 ? void 0 : filter.model) || '',
                    max_price: maxPrice,
                    min_price: minPrice,
                },
                event: 'all_outboards_filter',
            };
            gtmEvent(gtmPayload);
            break;
        case PSP_SITE_NAME:
            // TODO: add max and min price when psp price filter is enabled
            gtmPayload = {
                filters: omitBy({
                    category: `${getGtmTagValue(vehicleType)} : ${(_a = filter === null || filter === void 0 ? void 0 : filter.model) !== null && _a !== void 0 ? _a : ''}`,
                    year: getGtmTagValue(filter === null || filter === void 0 ? void 0 : filter.year),
                    exteriorColor: getGtmTagValue(filter === null || filter === void 0 ? void 0 : filter.exteriorColor),
                    transmission: getGtmTagValue(filter === null || filter === void 0 ? void 0 : filter.transmissionName),
                }, isUndefined),
                event: 'all_psp_filter',
            };
            gtmEvent(gtmPayload);
            break;
        case PE_SITE_NAME:
            gtmPayload = {
                filters: omitBy({
                    category: getPECategory(filter),
                    exteriorColor: getGtmTagValue(filter === null || filter === void 0 ? void 0 : filter.exteriorColor),
                }, isUndefined),
                event: 'filter_apply',
            };
            gtmEvent(gtmPayload);
            break;
        default:
            gtmPayload = {
                filters: filter,
                trims_available: trimsAvailable,
                event: 'all_vehicles_filter',
            };
            gtmEvent(gtmPayload);
            break;
    }
};
/**
 * maps the filterType property for the ModelListFilters
 *
 * @param {string} variant - the variant based on the productLine
 * @param {Array} filterTypes - how many trims are available on selected filter
 * @param {string} categoryFilterLabel - category filter label
 * @returns {} - returns the mapped configuration
 */
export const useConfiguration = ({ variant, filterTypes, categoryFilterLabel, singleSelectFilters }) => {
    const { t } = useTranslation();
    const filterCopy = [];
    const singleSelectCategories = singleSelectFilters;
    const colourFilterLabel = t('Pages.Models.Exploration.filterColourLabel');
    const transmissionFilterLabel = t('Pages.Models.Exploration.transmissionLabel');
    let categoryFilterLabelValue = t('Pages.Models.Exploration.filterCategoryLabel');
    let shouldUseModelNamesFromFieldsData = false;
    let colorFilterHeight;
    let defaultDesktopExpandedCategories = [];
    let defaultMobileExpandedCategories = [];
    let filterContainerWidth;
    let headerWidth;
    let hoverBtnColor = 'tertiary';
    let isModelFilterHidden;
    let isPriceFilterHidden;
    let mappedFilterType = filterTypes;
    let selectedBtnColor = 'success';
    let showExteriorColorsLabel;
    let toggleContainerWidth;
    let wrapperWidth;
    let shouldUseQueryParams = false;
    const DesignFilterCategory = {
        filterCategory: {
            fields: {
                name: DESIGN_FEATURES_FIELD_NAME,
                filterCategoryName: {
                    value: colourFilterLabel,
                },
                items: [],
            },
        },
    };
    const transmissionsFilterCategory = {
        filterCategory: {
            fields: {
                name: AVAILABLE_TRANSMISSIONS_FIELD_NAME,
                filterCategoryName: {
                    value: transmissionFilterLabel,
                },
                items: [],
            },
        },
    };
    switch (variant) {
        case variant1:
            categoryFilterLabelValue = t('Pages.Models.Exploration.filterModelsLabel');
            colorFilterHeight = '125px';
            defaultDesktopExpandedCategories = [];
            filterContainerWidth = undefined;
            headerWidth = '100%';
            isPriceFilterHidden = false;
            showExteriorColorsLabel = true;
            toggleContainerWidth = undefined;
            wrapperWidth = undefined;
            break;
        case variant2:
            filterContainerWidth = ['100%', '100%', 'calc(100% - 3px)'];
            headerWidth = ['100%', '100%', 'calc(100% - 3px)'];
            isPriceFilterHidden = false;
            toggleContainerWidth = ['100%', '100%', 'calc(100% - 3px)'];
            wrapperWidth = ['100%', '100%', 'calc(100% + 3px)'];
            break;
        case variant3:
            filterCopy.push(transmissionsFilterCategory, DesignFilterCategory);
            colorFilterHeight = '150px';
            defaultMobileExpandedCategories = ['vehicle-type'];
            isPriceFilterHidden = true;
            mappedFilterType = filterCopy;
            showExteriorColorsLabel = false;
            break;
        case variant4:
            categoryFilterLabelValue = categoryFilterLabel;
            defaultDesktopExpandedCategories = ['models'];
            defaultMobileExpandedCategories = ['attachment', 'productUse', 'fuelType', 'startType', 'models'];
            hoverBtnColor = 'tertiary';
            isModelFilterHidden = false;
            shouldUseModelNamesFromFieldsData = true;
            selectedBtnColor = 'success';
            shouldUseQueryParams = true;
            break;
        default:
            break;
    }
    return {
        categoryFilterLabel: categoryFilterLabelValue,
        colorFilterHeight,
        colourFilterLabel,
        defaultDesktopExpandedCategories,
        shouldUseModelNamesFromFieldsData,
        defaultMobileExpandedCategories,
        filterContainerWidth,
        headerWidth,
        hoverBtnColor,
        isModelFilterHidden,
        isPriceFilterHidden,
        mappedFilterType,
        selectedBtnColor,
        showExteriorColorsLabel,
        singleSelectCategories,
        toggleContainerWidth,
        transmissionFilterLabel,
        wrapperWidth,
        shouldUseQueryParams,
    };
};
export const getFilterLabel = (variant, fieldName) => {
    if (!fieldName)
        return null;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation();
    let filterLabel = fieldName;
    switch (variant) {
        case variant3:
            if (fieldName === TRANSMISSIONS_FIELD_NAME) {
                filterLabel = t('Pages.Models.Exploration.filterTrimLabel');
            }
            break;
        default:
            break;
    }
    return filterLabel;
};
